import { Component, Input, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-product-default',
  templateUrl: './select-product-default.component.html',
  styleUrls: ['./select-product-default.component.scss']
})
export class SelectProductDefaultComponent implements OnDestroy {

  @Input() showAll: boolean = false;
  public items: any[] = [
    { name: 'Total', value: 'total' },
    { name: 'Regular', value: 'regular' },
    { name: 'Premium', value: 'premium' },
    { name: 'Diesel', value: 'diesel' }
  ];

  public productTypeDefault: any = [];
  public productTypeAll: any = [];
  public ngxDisabled = false;
  productTypeAll$: Subscription;
  productTypeDefault$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.productTypeDefault$ = this.sharedService.sharedProductGasolineDefault.subscribe(productTypeDefault => {
      if (this.productTypeDefault !== productTypeDefault) {
        this.productTypeDefault = productTypeDefault;
      }
    });

    this.productTypeAll$ = this.sharedService.sharedAllProducts.subscribe(productTypeAll => {
      if (this.productTypeAll !== productTypeAll) {
        this.productTypeAll = productTypeAll;
        if(!productTypeAll !&& this.ngxDisabled){
          this.sharedService.nextProductGasolineDefault = 'regular';
        }
        this.ngxDisabled = this.productTypeAll;
      }
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnInit() {
    if (this.showAll) {
      this.sharedService.nextProductGasolineDefault = 'total';
    }
  }

  ngOnDestroy() {
    this.productTypeDefault$.unsubscribe();
    this.productTypeAll$.unsubscribe();
  }

  changeProductAll(event: any) {
    this.productTypeDefault = event;
    this.sharedService.nextProductGasolineDefault = this.productTypeDefault;
  }
}
